import { useIntlayer } from 'react-intlayer';

import { LocalizedLink } from '~/components/LocalizedLink';
import { SOCIAL_LINKS } from '~/constants';
import { openExternal } from '~/utils/open-external';

export const Footer = () => {
  const content = useIntlayer('footer');

  return (
    <footer className="bg-graphite-dark px-4 py-10 md:px-8 lg:px-20">
      <div className="max-w-[1440px] mx-auto flex flex-col gap-[60px]">
        {/* Mobile: Logo at top, Desktop: Logo on left */}
        <div className="flex flex-col md:flex-row items-start justify-between gap-[60px] md:gap-4">
          {/* Logo */}
          <div className="shrink-0">
            <img
              src="/assets/images/trypillian-logo-white-horizontal.svg"
              alt="Trypillian"
              className="h-5 w-auto md:h-6"
            />
          </div>

          {/* Footer columns - mobile: stacked, desktop: horizontal */}
          <div className="flex flex-col md:flex-row gap-10 md:gap-[80px] w-full md:w-auto md:justify-end">
            {/* Address */}
            <div className="flex flex-col gap-3 md:gap-[18px] w-full md:w-[131px]">
              <p className="font-mono text-xs tracking-[0.12px] uppercase text-[#7b8d9e]">
                {content.address.title}
              </p>
              <div className="text-sm text-white tracking-[0.14px]">
                <p className="mb-0">{content.address.street}</p>
                <p className="mb-0">{content.address.city}</p>
                <p className="">{content.address.country}</p>
              </div>
            </div>

            {/* Main */}
            <div className="flex flex-col gap-3 md:gap-[18px] w-full md:w-[80px]">
              <p className="font-mono text-xs tracking-[0.12px] uppercase text-[#7b8d9e]">
                {content.main.title}
              </p>
              <div className="flex flex-col gap-2 md:gap-3 text-sm text-white tracking-[0.14px]">
                {/* <LocalizedLink to="/mission" className="hover:text-white/70 transition-colors">
                  {content.main.mission}
                </LocalizedLink>
                <LocalizedLink to="/vision" className="hover:text-white/70 transition-colors">
                  {content.main.vision}
                </LocalizedLink> */}
                <LocalizedLink
                  to="#products"
                  className="hover:text-white/70 transition-colors"
                >
                  {content.main.products}
                </LocalizedLink>
                <LocalizedLink
                  to="/about"
                  className="hover:text-white/70 transition-colors"
                >
                  {content.main.about}
                </LocalizedLink>
                <LocalizedLink
                  to="/team"
                  className="hover:text-white/70 transition-colors"
                >
                  {content.main.team}
                </LocalizedLink>
                <LocalizedLink
                  to="/vacancies"
                  className="text-sm text-white tracking-[0.14px] hover:text-white/70 transition-colors"
                >
                  {content.main.vacancies}
                </LocalizedLink>
                <a
                  href={SOCIAL_LINKS.LINKEDIN}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white tracking-[0.14px] hover:text-white/70 transition-colors"
                  onClick={(e) => {
                    e.preventDefault();
                    openExternal(SOCIAL_LINKS.LINKEDIN);
                  }}
                >
                  {content.main.contacts}
                </a>
              </div>
            </div>

            {/* Support */}
            <div className="flex flex-col gap-3 md:gap-[18px] w-full md:w-[100px]">
              <p className="font-mono text-xs tracking-[0.12px] uppercase text-[#7b8d9e]">
                {content.support.title}
              </p>
              <div className="flex flex-col gap-2 md:gap-3 text-sm text-white tracking-[0.14px]">
                <LocalizedLink
                  to="/privacy"
                  className="hover:text-white/70 transition-colors"
                >
                  {content.support.privacyPolicy}
                </LocalizedLink>
                <LocalizedLink
                  to="/cookies"
                  className="hover:text-white/70 transition-colors"
                >
                  {content.support.cookiesPolicy}
                </LocalizedLink>
              </div>
            </div>

            {/* Quick Contact */}
            <div className="flex flex-col gap-3 md:gap-[18px] w-full md:w-[100px]">
              <p className="font-mono text-xs tracking-[0.12px] uppercase text-[#7b8d9e]">
                {content.quickContact.title}
              </p>
              <a
                href={SOCIAL_LINKS.LINKEDIN}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white tracking-[0.14px] hover:text-white/70 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  openExternal(SOCIAL_LINKS.LINKEDIN);
                }}
              >
                {content.quickContact.linkedin}
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <p className="text-sm text-white tracking-[0.14px]">
          {content.copyright}
        </p>
      </div>
    </footer>
  );
};
